/**
 * 附加参数规则，在后续规则中可能会使用一些附加参数，由该规则文件提供附加参数
 * 通用额外参数
 * 权重区间： 60000 - 50000 步长100
 */

export default function Attached(R){
	return [
		{
			// 添加额外数字参
			priority: 60000,
			condition: function(R) {
		        R.when( _.filter(this.ruleSuite, (item) => /^add-num-.*$/.test(item)).length);
		    },
		    consequence: function(R) {
		    	this.attached.number = Number(_.filter(this.ruleSuite, (item) => /^add-num-.*$/.test(item))[0].split('add-num-')[1]);
		        R.next();
		    }
		},
		{
			// 添加额外位置参
			priority: 59900,
			condition: function(R) {
		        R.when( _.filter(this.ruleSuite, (item) => /^add-posnum-.*$/.test(item)).length);
		    },
		    consequence: function(R) {
		    	this.attached.posnum = Number(_.filter(this.ruleSuite, (item) => /^add-posnum-.*$/.test(item))[0].split('add-posnum-')[1]);
		        R.next();
		    }
		},
		{
			// 添加额外标记
			priority: 59800,
			condition: function(R) {
		        R.when( _.filter(this.ruleSuite, (item) => /^add-flag-.*$/.test(item)).length);
		    },
		    consequence: function(R) {
		    	this.attached.flag = _.filter(this.ruleSuite, (item) => /^add-flag-.*$/.test(item))[0].split('add-flag-')[1];
		        R.next();
		    }
		}
	]
}